import React, { useCallback, useEffect, useState } from 'react';
import { Button, Checkbox, Chip, Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Fab, FormControl, FormControlLabel, Grid, InputLabel, List, ListItem, ListItemIcon, ListItemText, MenuItem, Paper, Select, Stack, SvgIcon, TableContainer, TextField, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/system';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { LoadingButton } from '@mui/lab';
import { Add, Search, TableView } from '@mui/icons-material';
import Tableview from 'app/shared/Tableview';
import ShoppingCartCheckoutSharpIcon from '@mui/icons-material/ShoppingCartCheckoutSharp';
import NoDataPlaceholder from 'app/shared/NoDataPlaceholder';
import { useNavigate } from 'react-router-dom';
import SearchResult from '../searchResult';
import './invetory.css'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { DataGrid } from '@mui/x-data-grid';
import ExcelGenerate, { ExcelGenerateAdmin } from 'app/shared/ExcelGenerate/ExcelGenerateForSearch';
import AutoAwesomeMotionOutlinedIcon from '@mui/icons-material/AutoAwesomeMotionOutlined';
import DiamondIcon from '@mui/icons-material/Diamond';
import SearchResultUser from './singleResultView';
import { isMobileDevice } from 'app/utils/modifyArrayOfObjectsKeys';
import JumboConfirmDialog from '@jumbo/components/JumboConfirmDialog';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
function SingleShapeList({setRightComp}) {
  const [isSingle, setisSingle] = useState(true)
  const [resultView, setResultView] = useState(false)
  const [data, setData] = useState({"SHAPE":[{"CLASS_NAME":"ico-shp icon-round-shape","name":"ROUND"},{"name":"OVAL","CLASS_NAME":"ico-shp icon-oval-shape"},{"name":"PEAR","CLASS_NAME":"ico-shp icon-pear-shape"},{"name":"MARQUISE","CLASS_NAME":"ico-shp icon-marquise-shape"},{"name":"HEART","CLASS_NAME":"ico-shp icon-heart-shape"},{"name":"EMERALD","CLASS_NAME":"ico-shp icon-emerald-shape"},{"name":"CUSHION","CLASS_NAME":"ico-shp icon-cushion-shape"},{"name":"PRINCESS","CLASS_NAME":"ico-shp icon-princess-shape"},{"name":"RADIANT","CLASS_NAME":"ico-shp icon-radiant-shape"},{"name":"ASSCHER","CLASS_NAME":"ico-shp icon-radiant-shape"},{"name":"OTHER","CLASS_NAME":"ico-shp icon-others-shape"}],"COLOR":[{"CLASS_NAME":null,"name":"D"},{"name":"E","CLASS_NAME":null},{"name":"F","CLASS_NAME":null},{"name":"G","CLASS_NAME":null},{"name":"H","CLASS_NAME":null},{"name":"I","CLASS_NAME":null},{"name":"J","CLASS_NAME":null},{"name":"K","CLASS_NAME":null}],"CLARITY":[{"CLASS_NAME":null,"name":"VVS1"},{"name":"VVS2","CLASS_NAME":null},{"name":"VS","CLASS_NAME":null},{"name":"VS1","CLASS_NAME":null},{"name":"VS2","CLASS_NAME":null},{"name":"SI1","CLASS_NAME":null},{"name":"SI2","CLASS_NAME":null}],"LAB":[{"CLASS_NAME":null,"name":"IGI"},{"name":"GIA","CLASS_NAME":null}],"CUT":[{"CLASS_NAME":null,"name":"ID"},{"name":"EX","CLASS_NAME":null},{"name":"VG","CLASS_NAME":null}],"POLISH":[{"CLASS_NAME":null,"name":"EX"},{"name":"VG","CLASS_NAME":null}],"SYMM":[{"CLASS_NAME":null,"name":"EX"},{"name":"VG","CLASS_NAME":null}]})
  const [searchData, setSearchData] = useState({})
  const [stoneData, setstoneData] = useState(null)
  const [advanceSearchDialoge, setAdvanceSearchDialoge] = useState(false);
  const [PostDemandDialoge, setPostDemandDialoge] = useState(false);

  const swal = useSwalWrapper();
  const navigate = useNavigate()
  // useEffect(() => {
  //   jwtAuthAxios.get('search/parmas?type=single').then(res => {
  //     console.log(res.data.data);
  //     setData(res.data.data)
  //   }

  //   ).catch(e => {
  //     swal.fire({
  //       icon: 'error',
  //       text: 'Internal server Error',
  //     });
  //   })
  // }, [])
  const PostDemandHandler= async () => {
    await jwtAuthAxios.post('mail/postdemand', searchData).then(async res => {
      swal.fire({
        icon:'success',
        text:res.data.message,
      })
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      });
    })
    // alert(JSON.stringify(searchData))
    // await stoneSearchHandler()
  }
  const stoneSearchHandler = async () => {
    // if(searchData.SHAPE){
    await jwtAuthAxios.post('search/stoneUser', searchData).then(async res => {
      // console.log(res.data.data);
      setRightComp(null)
      if(res?.data?.result?.length >0){
        setResultView(res.data.result)        
      }else{
        setPostDemandDialoge(true)
      }
      await jwtAuthAxios.post('search/stone', {...searchData,type:'save'})
      return
      // navigate('/search-result/'+res.data.SearchId)
      // setstoneData(res.data.data)
      // setData(res.data.data)
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      });
    })
    // } 
    // /else{
    //   swal.fire({
    //     icon: 'error',
    //     text: 'Please Select Shape',
    //   });
    // }///////

    // console.log(searchData);
  }
  const handleChangeSearchData = (type, data) => {
    let updatedTypeArray = searchData[type] ? [...searchData[type]] : []; // Create a copy or an empty array

    data.forEach(item => {
      const index = updatedTypeArray.indexOf(item.name);
      if (index !== -1) {
        // name found in the array, remove it
        updatedTypeArray.splice(index, 1);
        // console.log(`Removed ${item.name} from the array`);
      } else {
        // name not found in the array, add it
        updatedTypeArray.push(item.name);
        // console.log(`Added ${item.name} to the array`);
      }
    });

    setSearchData({ ...searchData, [type]: updatedTypeArray }); // Update searchData[type] with the modified array
    // console.log({ type, data });
  };
  useEffect(()=>{
    setRightComp(<Fab size='small' variant="contained" onClick={stoneSearchHandler} sx={{ display: 'flex', margin: '5px auto', mt: 3,ml:'auto !important' }} color="primary">
    <Search/>
  </Fab>)
  },[])
  return resultView ? <SearchResultUser searchForm={searchData} data={resultView} fallBack={setResultView} /> : (<>
    <div>
      {stoneData == null ? <Paper>
        {data && <List>
          {Object.keys(data).map((sfname, index) => (
            <ListItem key={sfname}>
              <Grid container key={sfname}>
                <Grid item xl={1} lg={2} xs={12}>
                  <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>{sfname}</Typography>
                </Grid>
                <Grid item lg={10} xl={11}>
                  <Stack flexWrap={'wrap'} direction={'row'} row={2.5}>
                    {data[sfname].map(item => <Paper onClick={() => { handleChangeSearchData(sfname, [item]) }} key={item.name} sx={{ m: 0.3, px: 1, py: 0.5, width: '80px', textAlign: 'center', cursor: 'pointer', color: (theme) => searchData[sfname] && searchData[sfname].indexOf(item.name) != -1 ? theme.palette.success.main : '', borderColor: (theme) => searchData[sfname] && searchData[sfname].indexOf(item.name) != -1 ? theme.palette.success.main : '' }} variant={"outlined"}>{item.CLASS_NAME && <i className={item.CLASS_NAME} style={{ fontSize: '50px', display: 'block', marginBottom: '-22px' }}></i>}{item.name}</Paper>)}
                  </Stack>
                </Grid>
              </Grid>
            </ListItem>
          ))}
          <ListItem>
            <Grid container >
              <Grid item xl={1} lg={2} xs={12}>
                <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Carats</Typography>
              </Grid>
              <Grid item lg={5} xl={11} xs={12}>
                <Grid container spacing={2}>
                  <Grid item md={2} xs={6}>
                    <TextField defaultValue={searchData.FromCarate} size='small' onInput={e => setSearchData({ ...searchData, FromCarate: e.target.value })} type='number' min={'0'} id="FromCarate" label="From Carate" variant="outlined" />
                  </Grid>
                  <Grid item md={2} xs={6}>
                    <TextField size='small' defaultValue={searchData.ToCarate} type='number' onInput={e => setSearchData({ ...searchData, ToCarate: e.target.value })} min={'0'} id="To Carate" label="To Carate" variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container >
              <Grid item xl={1} lg={2} xs={12}>
                <Typography onInput={e => setSearchData({ ...searchData, stoneCert: e.target.value })} sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Stone /cert no.</Typography>
              </Grid>
              <Grid item lg={9} xs={11}>
                {/* <Grid container spacing={2}> */}
                  {/* <Grid item md={12} xs={12}> */}
                    <TextField defaultValue={searchData.stoneCert} fullWidth onInput={e => setSearchData({ ...searchData, stoneCert: e.target.value })} size='small' id="Stone-certno" label="Stone /cert no." variant="outlined" helperText="Multiple Stone Can Be Pasted." />
                  {/* </Grid> */}
                {/* </Grid> */}
              </Grid>
            </Grid>
          </ListItem>
          {/* <Button sx={{ ml: 3, mt: 3 }} variant='text' onClick={() => setAdvanceSearchDialoge(true)} startIcon={<Add />}>Advance Search</Button> */}
          <Grid container>
            <Grid item lg={11} xl={6}>
              <Button sx={{ ml: 3, mt: 3 ,mb:2}} variant='outlined' onClick={() => setAdvanceSearchDialoge(true)} startIcon={<Add />}>Advance Search</Button>
            </Grid>
            <Grid item lg={12} xl={6} sx={{ml:3}}>
              <FormControlLabel
                control={<Checkbox checked={searchData?.A} onChange={(e) => setSearchData({ ...searchData, A: e.target.checked })} name="A" />}
                label="Available only"
              />
              <FormControlLabel
                control={<Checkbox checked={searchData?.Memo} onChange={(e) => setSearchData({ ...searchData, Memo: e.target.checked })} name="memo" />}
                label="Memo"
              />
              <FormControlLabel
                control={<Checkbox checked={searchData?.Hold} onChange={(e) => setSearchData({ ...searchData, Hold: e.target.checked })} name="hold" />}
                label="Hold"
              />
            </Grid>
          </Grid>
          <ListItem>
            <Grid container alignItems={'end'}>
              <LoadingButton variant="contained" onClick={stoneSearchHandler} sx={{ display: 'flex', margin: '2px auto' }} color="primary">
                Search
              </LoadingButton>
            <LoadingButton variant="contained" onClick={stoneSearchHandler} sx={{ display: 'flex', margin: '5px auto', mt: 3 }} color="primary">
                  Post Your Demand
                </LoadingButton>
            </Grid></ListItem>
        </List>}
      </Paper> : <>{stoneData && stoneData.length > 0 ? <Tableview body={stoneData} /> : <NoDataPlaceholder />}</>}
      <Dialog open={advanceSearchDialoge} onClose={() => setAdvanceSearchDialoge(false)}>
        <DialogTitle>Advance Search</DialogTitle>
        <DialogContent>
          {/* <DialogContentText> */}
          <ListItem>
            <Grid container >
              <Grid item sx={12}>
                <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Table %</Typography>
              </Grid>
              <Grid item xl={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextField size='small' defaultValue={searchData.FromTable_per} onInput={e => setSearchData({ ...searchData, FromTable_per: e.target.value })} type='number' min={'0'} id="FromTable_per" label="From Table" variant="outlined" />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField size='small' type='number' defaultValue={searchData.ToTable_per} onInput={e => setSearchData({ ...searchData, ToTable_per: e.target.value })} min={'0'} id="ToTable_per" label="To Table" variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container >
              <Grid item sx={12}>
                <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Depth %</Typography>
              </Grid>
              <Grid item xl={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextField size='small' defaultValue={searchData.FromDepth_per} onInput={e => setSearchData({ ...searchData, FromDepth_per: e.target.value })} type='number' min={'0'} id="FromDepth_per" label="From Depth" variant="outlined" />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField size='small' type='number' defaultValue={searchData.ToDepth_per} onInput={e => setSearchData({ ...searchData, ToDepth_per: e.target.value })} min={'0'} id="ToDepth_per" label="To Depth" variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container >
              <Grid item sx={12}>
                <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Ratio</Typography>
              </Grid>
              <Grid item xl={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextField size='small' defaultValue={searchData.FromRatio} onInput={e => setSearchData({ ...searchData, FromRatio: e.target.value })} type='number' min={'0'} id="FromRatio" label="From Ratio" variant="outlined" />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField size='small' defaultValue={searchData.ToRatio} type='number' onInput={e => setSearchData({ ...searchData, ToRatio: e.target.value })} min={'0'} id="ToRatio" label="To Ratio" variant="outlined" />
                  </Grid>
                </Grid>
               
               
                <LoadingButton variant="contained" onClick={stoneSearchHandler} sx={{ display: 'flex', margin: '5px auto', mt: 3 }} color="primary">
                  Search
                </LoadingButton>
              </Grid>
            </Grid>
          </ListItem>
          {/* </DialogContentText> */}
        </DialogContent></Dialog>
        <JumboConfirmDialog icon={<SearchOffOutlinedIcon/>} title={"Are you sure you want to post this demand?"} open={PostDemandDialoge} onClose={()=> setPostDemandDialoge(false)} message={"We currently do not have the stone you are looking for in our stock."} onConfirm={PostDemandHandler}/>
    </div></>
  );
}
function ParcelShapeList({setRightComp}) {
  const [isSingle, setisSingle] = useState(true)
  const [resultView, setResultView] = useState(false)
  const [data, setData] = useState({"SHAPE":[{"CLASS_NAME":"ico-shp icon-round-shape","name":"ROUND"},{"name":"OVAL","CLASS_NAME":"ico-shp icon-oval-shape"},{"name":"PEAR","CLASS_NAME":"ico-shp icon-pear-shape"},{"name":"MARQUISE","CLASS_NAME":"ico-shp icon-marquise-shape"},{"name":"HEART","CLASS_NAME":"ico-shp icon-heart-shape"},{"name":"EMERALD","CLASS_NAME":"ico-shp icon-emerald-shape"},{"name":"CUSHION","CLASS_NAME":"ico-shp icon-cushion-shape"},{"name":"PRINCESS","CLASS_NAME":"ico-shp icon-princess-shape"},{"name":"RADIANT","CLASS_NAME":"ico-shp icon-radiant-shape"},{"name":"BAGUETTE","CLASS_NAME":"ico-shp icon-baguette-shape"},{"name":"OTHERS","CLASS_NAME":"ico-shp icon-others-shape"}],"CARAT":[{"CLASS_NAME":null,"name":"-2"},{"name":"+2-6.5","CLASS_NAME":null},{"name":"+6.5-11","CLASS_NAME":null},{"name":"+11-14","CLASS_NAME":null},{"name":"1/10","CLASS_NAME":null},{"name":"1/6","CLASS_NAME":null},{"name":"1/5","CLASS_NAME":null},{"name":"1/4","CLASS_NAME":null},{"name":"1/3","CLASS_NAME":null},{"name":"3/8","CLASS_NAME":null},{"name":"1/2","CLASS_NAME":null},{"name":"3/4","CLASS_NAME":null},{"name":"None","CLASS_NAME":null},{"name":"+7-10","CLASS_NAME":null},{"name":"1-1.49","CLASS_NAME":null}],"COLOR":[{"CLASS_NAME":null,"name":"G+"},{"name":"F.I.BLUE","CLASS_NAME":null}],"CLARITY":[{"CLASS_NAME":null,"name":"VS+"},{"name":"SI+","CLASS_NAME":null}]})
  const [searchData, setSearchData] = useState({})
  const [stoneData, setstoneData] = useState(null)
  const [advanceSearchDialoge, setAdvanceSearchDialoge] = useState(false);
  const swal = useSwalWrapper();
  const navigate = useNavigate()
  // useEffect(() => {
  //   jwtAuthAxios.get('search/parmas').then(res => {
  //     console.log(res.data.data);
  //     setData(res.data.data)
  //   }

  //   ).catch(e => {
  //     swal.fire({
  //       icon: 'error',
  //       text: 'Internal server Error',
  //     });
  //   })
  // }, [])
  const stoneSearchHandler = async () => {
    // if(searchData.SHAPE){
    await jwtAuthAxios.post('search/bulk/stone', searchData).then(res => {
      // console.log(res.data.data);
      setRightComp(null);
      setResultView(res.data.result)
      // console.log(res.data.result);
      // navigate('/search-result/'+res.data.SearchId)
      // setstoneData(res.data.data)
      // setData(res.data.data)
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      });
    })
    // } 
    // /else{
    //   swal.fire({
    //     icon: 'error',
    //     text: 'Please Select Shape',
    //   });
    // }///////

    // console.log(searchData);
  }
  useEffect(()=>{
    setRightComp(<Fab size='small' variant="contained" onClick={stoneSearchHandler} sx={{ display: 'flex', margin: '5px auto', mt: 3,ml:'auto !important' }} color="primary">
    <Search/>
  </Fab>)
  },[])
  const handleChangeSearchData = (type, data) => {
    let updatedTypeArray = searchData[type] ? [...searchData[type]] : []; // Create a copy or an empty array

    data.forEach(item => {
      const index = updatedTypeArray.indexOf(item.name);
      if (index !== -1) {
        // name found in the array, remove it
        updatedTypeArray.splice(index, 1);
        // console.log(`Removed ${item.name} from the array`);
      } else {
        // name not found in the array, add it
        updatedTypeArray.push(item.name);
        // console.log(`Added ${item.name} to the array`);
      }
    });

    setSearchData({ ...searchData, [type]: updatedTypeArray }); // Update searchData[type] with the modified array
    // console.log({ type, data });
  };
  return resultView ? <ParcelResultView ResultData={resultView} fallBack={setResultView} /> : (<>
    <div>
      {stoneData == null ? <Paper>
        {data && <List>
          {Object.keys(data).map((sfname, index) => (
            <ListItem key={sfname}>
              <Grid container key={sfname}>
                <Grid item xl={1} lg={2}  xs={12}>
                  <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>{sfname}</Typography>
                </Grid>
                <Grid item lg={10} xl={11}>
                  <Stack direction={'row'} row={2.5} flexWrap={'wrap'}>
                    {data[sfname].map(item => <Paper onClick={() => { handleChangeSearchData(sfname, [item]) }} key={item.name} sx={{ m: 0.3, px: 1, py: 0.5, textAlign: 'center', width: '80px', cursor: 'pointer', color: (theme) => searchData[sfname] && searchData[sfname].indexOf(item.name) != -1 ? theme.palette.success.main : '', borderColor: (theme) => searchData[sfname] && searchData[sfname].indexOf(item.name) != -1 ? theme.palette.success.main : '' }} variant={"outlined"}>{item.CLASS_NAME && <i className={item.CLASS_NAME} style={{ fontSize: '50px', display: 'block', marginBottom: '-22px' }}></i>}{item.name}</Paper>)}
                  </Stack>
                </Grid>
              </Grid>
            </ListItem>
          ))}
          {/* <ListItem>
            <Grid container >
              <Grid item xl={1} lg={2} sx={3}>
                <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Carats</Typography>
              </Grid>
              <Grid item lg={5} xl={11}>
                <Grid container spacing={2}>
                  <Grid item xs={2}>
                    <TextField defaultValue={searchData.FromCarate} size='small' onInput={e => setSearchData({ ...searchData, FromCarate: e.target.value })} type='number' min={'0'} id="FromCarate" label="From Carate" variant="outlined" />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField size='small' defaultValue={searchData.ToCarate} type='number' onInput={e => setSearchData({ ...searchData, ToCarate: e.target.value })} min={'0'} id="To Carate" label="To Carate" variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ListItem> */}
          <ListItem>
            <Grid container >
              <Grid item xl={1} lg={2} xs={12}>
                <Typography onInput={e => setSearchData({ ...searchData, stoneCert: e.target.value })} sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Lot no.</Typography>
              </Grid>
              <Grid item lg={5} xl={11} xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField defaultValue={searchData.stoneCert} onInput={e => setSearchData({ ...searchData, stoneCert: e.target.value })} size='small' id="Stone-certno" label="Stone /cert no." variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={11} xl={6}>
                <Button sx={{ ml: 0, mt: 3 }} variant='outlined' onClick={() => setAdvanceSearchDialoge(true)} startIcon={<Add />}>Advance Search</Button>
              </Grid>
              {/* <Grid item lg={12} xl={6}>
                <FormControlLabel
                  control={<Checkbox checked={searchData?.available} onChange={(e) => setSearchData({ ...searchData, Available: e.target.checked })} name="available" />}
                  label="Available"
                />
                <FormControlLabel
                  control={<Checkbox checked={searchData?.memo} onChange={(e) => setSearchData({ ...searchData, Memo: e.target.checked })} name="memo" />}
                  label="Memo"
                />
                <FormControlLabel
                  control={<Checkbox checked={searchData?.hold} onChange={(e) => setSearchData({ ...searchData, Hold: e.target.checked })} name="hold" />}
                  label="Hold"
                />
              </Grid> */}
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container alignItems={'end'}>
              <LoadingButton variant="contained" onClick={stoneSearchHandler} sx={{ display: 'flex', margin: '2px auto' }} color="primary">
                Search
              </LoadingButton>
            <LoadingButton variant="contained" onClick={stoneSearchHandler} sx={{ display: 'flex', margin: '5px auto', mt: 3 }} color="primary">
                  Post Your Demand
                </LoadingButton>
            </Grid></ListItem>
        </List>}
      </Paper> : <>{stoneData && stoneData.length > 0 ? <Tableview body={stoneData} /> : <NoDataPlaceholder />}</>}
      <Dialog open={advanceSearchDialoge} onClose={() => setAdvanceSearchDialoge(false)}>
        <DialogTitle>Advance Search</DialogTitle>
        <DialogContent>
          {/* <DialogContentText> */}
          <ListItem>
            <Grid container >
              <Grid item sx={12}>
                <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Table %</Typography>
              </Grid>
              <Grid item xl={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextField size='small' defaultValue={searchData.FromTable_per} onInput={e => setSearchData({ ...searchData, FromTable_per: e.target.value })} type='number' min={'0'} id="FromTable_per" label="From Table" variant="outlined" />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField size='small' type='number' defaultValue={searchData.ToTable_per} onInput={e => setSearchData({ ...searchData, ToTable_per: e.target.value })} min={'0'} id="ToTable_per" label="To Table" variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container >
              <Grid item sx={12}>
                <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Depth %</Typography>
              </Grid>
              <Grid item xl={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextField size='small' defaultValue={searchData.FromDepth_per} onInput={e => setSearchData({ ...searchData, FromDepth_per: e.target.value })} type='number' min={'0'} id="FromDepth_per" label="From Depth" variant="outlined" />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField size='small' type='number' defaultValue={searchData.ToDepth_per} onInput={e => setSearchData({ ...searchData, ToDepth_per: e.target.value })} min={'0'} id="ToDepth_per" label="To Depth" variant="outlined" />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ListItem>
          <ListItem>
            <Grid container >
              <Grid item sx={12}>
                <Typography sx={{ mt: 1, color: "text.secondary", fontSize: '16px', textTransform: 'capitalize' }} component={'h3'}>Ratio</Typography>
              </Grid>
              <Grid item xl={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <TextField size='small' defaultValue={searchData.FromRatio} onInput={e => setSearchData({ ...searchData, FromRatio: e.target.value })} type='number' min={'0'} id="FromRatio" label="From Ratio" variant="outlined" />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField size='small' defaultValue={searchData.ToRatio} type='number' onInput={e => setSearchData({ ...searchData, ToRatio: e.target.value })} min={'0'} id="ToRatio" label="To Ratio" variant="outlined" />
                  </Grid>
                </Grid>
                <LoadingButton variant="contained" onClick={stoneSearchHandler} sx={{ display: 'flex', margin: '5px auto', mt: 3 }} color="primary">
                  Search
                </LoadingButton>
              </Grid>
            </Grid>
          </ListItem>
          {/* </DialogContentText> */}
        </DialogContent></Dialog>
       
    </div></>
  );
}


const ParcelResultView  = ({ResultData,fallBack}) => {
  const [userParty, setUserParty] = useState(null)
  // const [selectedStoneDetails, setSelectedStoneDetails] = useState({ pcs: 0, cts: 0, rap: 0, disc: 0 })
  const [userSelectedParty, setUserSelectedParty] = useState(null)
  const isMobile =isMobileDevice();
  const [BLOADER, setBLOADER] = useState(false)
  const [SelectedStone, setSelectedStone] = useState([])
  const [SelectedStoneData, setSelectedStoneData] = useState([])
  const swal = useSwalWrapper();
  const navigate = useNavigate();
  const columns = [
    { field: "FL_MAIN_LOT", flex: 1, headerName: "Main Lot" },
    { field: "FL_SUB_LOT", flex: 1, headerName: "Sub Lot no." },
    { field: "FL_COLOR", flex: 1, headerName: "Color" },
    { field: "FL_CLARITY", flex: 1, headerName: "Clarity" },
    { field: "FL_CARATS", flex: 1,type:'number', headerName: "CTS" },
    { field: "FL_ASK_AMT", flex: 1,type:'number', headerName: "Rate/cts",renderCell: (params)=>Number(params.value)?.toFixed(2) },
    // { field: "FL_GREEN_AMT", flex: 1,type:'number', headerName: "Green Rate/cts",renderCell: (params)=>Number(params.value)?.toFixed(2) },
    // { field: "FL_RED_AMT", flex: 1,type:'number', headerName: "Red Rate/cts",renderCell: (params)=>Number(params.value)?.toFixed(2) },
  ]
  // useEffect(()=>{
  //   jwtAuthAxios.get(`master/helper?party=1`).then((res) => {
  //     setUserParty(res.data?.data?.PARTY || [])
  //   }).catch(e => {
  //     swal.fire({
  //       icon: 'error',
  //       text: 'Internal server Error',
  //     });
  //   })
  // },[])
  const AddtoBasketHandler = async () => {
    setBLOADER(true);
    await jwtAuthAxios.post(`user/userbasket`, {type:'I', "stone_id": SelectedStone,stype:'POLISH-PARCEL' }).then((res) => {
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
      navigate('/basket')
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      })
    }).finally(() => setBLOADER(false));
  }
  return  (<> 
  <Stack direction={'row'} style={{ justifyContent: 'end' }}
  spacing={{ xs: 1, sm: 2, md: 4 }} sx={{py:2}}>
     {isMobile?<Tooltip title={`Modify Search (${ResultData?.length})`}><Fab onClick={()=>fallBack(false)}  size='small' color='primary' variant="outlined"> <FilterAltIcon/></Fab></Tooltip> :
     <Button onClick={()=>fallBack(false)} variant="outlined" startIcon={<FilterAltIcon  fontSize={'30px'} />}  color='primary'>Modify Search ({ResultData?.length})</Button> }
    <ExcelGenerate  text={'Excel'} data={SelectedStoneData} />
    {isMobile?
    <Tooltip title={`Add To Basket`}><Fab loading={BLOADER} disabled={!SelectedStone.length > 0} onClick={AddtoBasketHandler}   size='small' color='primary' variant="outlined"> <ShoppingCartCheckoutSharpIcon/></Fab></Tooltip> :
  <LoadingButton loading={BLOADER} variant="contained" disabled={!SelectedStone.length > 0} onClick={AddtoBasketHandler} sx={{ display: 'flex', margin: '0 0px 22px auto' }} startIcon={<ShoppingCartCheckoutSharpIcon />} color="primary"> Add To Basket </LoadingButton>
}
</Stack><TableContainer component={Paper} className="result-table">
    {Array.isArray(ResultData) && ResultData.length > 0 ? <DataGrid
          rows={ResultData || []}
          columns={columns}
          pageSize={5}
          // apiRef={apiRef}
          density='compact'
          getRowId={(row) => row.FL_SUB_LOT}
          rowsPerPageOptions={[50, 100, 200]}
          sx={{ p: 0, fontSize: '16px' }}
          onRowSelectionModelChange={e=>setSelectedStone(e)}
          checkboxSelection
          // disableRowSelectionOnClick
        />:<NoDataPlaceholder/>}
  </TableContainer></>)

}
// function ParcelShapeList() {
//   return 'bulk'
// }
export default function UserSearch() {
  const [searchType, setSearchType] = useState('single');
  const [rightComp, setRightComp] = useState(null);
  const isMobile= isMobileDevice()
  return (<><Stack direction={"row"} sx={{ mb: 3 }} spacing={2}>

    {isMobile? <><Button variant={searchType != 'single' ? 'outlined' : 'contained'} onClick={() => setSearchType('single')}><DiamondIcon /></Button>
    {/* <Button variant={searchType == 'single' ? 'outlined' : 'contained'} onClick={() => setSearchType('bulk')}><AutoAwesomeMotionOutlinedIcon /></Button> */}
    </>
  :
    <><Button variant={searchType != 'single' ? 'outlined' : 'contained'} onClick={() => setSearchType('single')}>Polish Certified</Button>
    {/* <Button variant={searchType == 'single' ? 'outlined' : 'contained'} onClick={() => setSearchType('bulk')}>Polish Parcel</Button> */}
    </>}
    {rightComp && rightComp}
  </Stack>

    {searchType == 'single' ? <SingleShapeList setRightComp={setRightComp} /> : <ParcelShapeList  setRightComp={setRightComp}/>}</>)
}
UserSearch.Modulename = 'UserSearch'
